import { render } from "./FooterCTA.vue?vue&type=template&id=113a2d9f&scoped=true"
import script from "./FooterCTA.vue?vue&type=script&lang=js"
export * from "./FooterCTA.vue?vue&type=script&lang=js"

import "./FooterCTA.vue?vue&type=style&index=0&id=113a2d9f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113a2d9f"]])

export default __exports__